import "./App.css";
import MainRoutes from "./Components/Homepage/MainRoutes/MainRoutes";

function App() {
  return (
    <div className="App">
      <MainRoutes />
    </div>
  );
}

export default App;
